export default class ChatListModel {
  constructor () {
    this.isCustomer = false
    this.lastMessage = {
      content: '',
      id: '',
      sender: {
        name: '',
        photo: '',
        type: '',
      },
      timestamp: '',
      type: '',
    }
    this.lineId = ''
    this.name = ''
    this.notification = 0
    this.patientId = 0
    this.photo = ''
    this.patientStatus = ''
  }

  static fromJSON (json) {
    let chat = new ChatListModel()
    chat.lastMessage = json.lastMessage
    chat.lineId = json.lineId
    chat.name = json.name
    chat.notification = json.notification
    chat.patientId = json.patientId
    chat.photo = json.photo
    chat.patientStatus = json.patientStatus
    return chat
  }
}
